<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="visualNav">
          <ul>
            <a href="#/visual/product"><li class="icon_a"><span></span>产品<div></div></li></a>
            <a href="#/visual/developmentPlatform"><li class="icon_b"><span></span>开发平台<div></div></li></a>
            <a href="#/visual/apply"><li class="icon_c"><span></span>可视化应用<div></div></li></a>
            <a href="#/visual/digitalTwin"><li class="icon_d actived"><span></span>数字孪生应用<div></div></li></a>
            <a href="#/visual/caseIntroduction"><li class="icon_e"><span></span>案例介绍</li></a>
          </ul>
        </div>
      </div>
      <div class="solution">
        <div class="digital_1">
          <div class="share">
            <div style="height:45px;width:415px;margin:0 auto;"><h2>数字孪生应用</h2></div>
            <span></span>
          </div>       
          <div class="view-tip">
            <p class="title">大数据知识图谱与数据分析模型</p>
            <div class="detail">
              <div class="productImg fl_l"><img src="../../../public/visualImg/digtal.png" alt=""> </div>
              <ul class="fl_r">
                <li><span>- 第一阶段</span><p>将物理对象变为数字化模型 </p></li>
                <li><span>- 第二阶段</span><p>实时接收来自物理对象的数据，从而可以不断演化以保持与物理对象的一致</p></li>
                <li><span>- 第三阶段</span><p>基于数字孪生可进行分析、预测、诊断、训练等（仿真)，并将仿真结果反馈给物理对象，从而帮助用户对物理对象进行优化和决策</p></li>
                <li><span>- 第四阶段</span><p>面向数字孪生全生命周期（构建、演化、评估、管理、使用）的可视化平台</p></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="digital_2">
          <div class="view-tip">
            <p class="title">解决方案</p>
            <div class="detail">
              <p style="margin-top:0px">数字孪生生态系统：</p>
              <div class="productImg"><img src="../../../public/visualImg/digtal2.png" alt=""> </div>
            </div>
            <div class="detail">
              <p>数据采集分析：</p>
              <div class="productImg"><img src="../../../public/visualImg/digtal6.png" alt=""> </div>
            </div>
            <div class="detail">
              <p>数据湖管理平台：</p>
              <div class="productImg"><img src="../../../public/visualImg/digtal3.png" alt=""> </div>
            </div>
          </div>
        </div>       
        <div class="digital_3">
          <div class="view-tip">
            <p class="title">多维空间</p>
            <div class="detail">
              <p>数字孪生为用户创造的多维空间:</p>
                <div class="productImg"><img src="../../../public/visualImg/digtal4.png" alt=""> </div>
                <div class="productImg"><img src="../../../public/visualImg/digtal5.gif" alt=""> </div>
              </div>
            </div>
          </div>
        </div>
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'可视化',
          detail:'Visualization',
          src: require("../../../public/visualImg/visualbaner.png"),
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.share{
  padding:80px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
  .visualNav{
    width: 100%;
    height: 98px;
    margin-top: 60px;
    border-top: 1px solid rgba(51, 51, 51, 0.15);
    border-bottom: 1px solid rgba(51, 51, 51, 0.15);
    ul{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      text-align: center;
      vertical-align: middle !important;
      a{width: 100%;}
      li{
        height: 100px;
        line-height: 100px;
        width: 100%;
        div{
          width: 1px;
          height: 20px;
          background:#ccc ;
          float: right ;
          margin-top: 40px;
        }
      }
      li:hover{
        // background-color:rgb(212,239,253);
        a{
          color: #fff;
        }
      }
      .icon_a{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_a.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 70px;background-position-y: 38px;
      }
      .icon_a:hover{
        span{

          background: url("../../../public/visualImg/icon_a1.png") no-repeat;
        }
        background-position-x: 70px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .actived{color: #fff;}
      .icon_b{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_b.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 54px;background-position-y: 38px;
      }
      .icon_b:hover{
        span{

          background: url("../../../public/visualImg/icon_b1.png") no-repeat;
        }
        background-position-x: 54px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .icon_c{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_c.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 48px;background-position-y: 38px;
      }
      .icon_c:hover{
        span{
          background: url("../../../public/visualImg/icon_c1.png") no-repeat;
        }
        background-position-x: 48px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .icon_d{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_d.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 40px;background-position-y: 38px;
      }
      .actived,.icon_d:hover{
        span{

          background: url("../../../public/visualImg/icon_d1.png") no-repeat;
        }
        background-position-x: 40px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .icon_e{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_e.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
      }
      .icon_e:hover{
        span{

          background: url("../../../public/visualImg/icon_e1.png") no-repeat  ;
        }
        background-position-x: 54px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      
    }
    a{
      color: #333;
    }
    a:hover,a:active{
      color: #fff;
    }
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 90px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          padding-bottom: 20px;
          // width: 326px;
        }
      }
    }
  }
.productImg{
  img{
    width: 1200px;
    margin: 0 auto;
  }  
}
.digital_1{
  height: 802px;
  .fl_l{
    float: left;
    img{
      width: 600px
    }
  }
  .fl_r{
    float: right;
    width: 528px;
    margin-right: 20px;
    margin-top: 32px;
  }
}
.digital_2{
  height: 2191px;
  background-color: #F8F9FB;
  .view-tip{
    padding-top: 2px;
    p{
      margin-bottom: 32px;
      margin-top: 40px;
    }
  }
}
.digital_3{
  height: 796px;
  .view-tip{
    padding-top: 60px;
    p{
      margin-bottom: 32px;
    }
  }
}
.solution{
  // height:1460px;
}
</style>


// WEBPACK FOOTER //
// src/views/visual/digitalTwin.vue